module.exports = __webpack_public_path__ + "static_1727318417925/img/billboard_new.1e908a09.png";